const parseMoleTokenId = (tokenIdParam: string): number => {
  const tokenId = parseInt(tokenIdParam)
  if (Number.isInteger(tokenId) && tokenId >= 0) return tokenId
  return null
}

export default parseMoleTokenId
